import BigTplChooseFromTwoLegacy from '../../../class/template/bt/BigTplChooseFromTwoLegacy'
import VideoTemplateLegacy from '../../../class/template/VideoTemplateLegacy'
import App from '../../../class/App.js'
import {onJSBridgeConnected, onWebviewshow} from "../../../api";
import bigTplChoseFromTwo from "./bigTplChoseFromTwo";
import Webview from '../../../class/component/native/visible/Webview'
import PlayerView from '../../../class/component/native/visible/PlayerView'


window.MTG_LAUNCH_bigTplChoseFromTwoLegacy = function (cb) {
    App.onJSBridgeConnected(() => {
        /*App.initMultipleCampaigns(BigTplChooseFromTwoLegacy).then(({data, tpl})=>{
            const { campaignList } = data
            //util.fireEvent('MTG_onTemplateDataLoaded',tpl.campaignList)
            cb && (typeof cb === 'function') && cb(data)
            tpl.setSubTpls(campaignList, VideoTemplateLegacy)

            tpl.onAllTplPreloadFinished(()=>{
                App.videoBridgeReadyStatusHasReady()
            })

            App.onWebviewshow((res) => {
                console.warn('onWebviewshow((res) => {', {res})
                tpl.show(res)
            })
        })*/
        new PlayerView()
        new PlayerView()
        new PlayerView()
        new PlayerView()
        new PlayerView()
        let playerView = new PlayerView()
        new Webview()
        new Webview()
        new Webview()
        new Webview()
        new Webview()
        let webview = new Webview()


        console.log('=========>', webview)
        /*webview.nativeTest().then(()=>{

            console.log('000=========>', webview)
        })*/

        webview.test1().then(()=>{

            console.log('webview.test1=========>', webview)
        })

        webview.test2().then(()=>{

            console.log('webview.test2=========>', webview)
        })

        playerView.testCommon().then(()=>{
            console.log('playerView.testCommon=========>', playerView)
        })


        webview.testCommon().then(()=>{

            console.log('webview.testCommon=========>', webview)
        })

    })
}



